import React from 'react'
import {Field} from "formik";

type PropsType = {
    name?: string
    formikField?: boolean
    rightSection?: React.ReactNode | null
    className?: string
    containerClassName?: string
    noClassName?: boolean
    type?: 'text' | 'phone' | 'email' | 'number' | 'textarea'
    withMargin?: boolean
    disabled?: boolean
    autoComplete?: boolean | "off"
    placeholder?: string
    onInput?: (e: any) => void
    onChange?: (e: any) => void
    onClick?: (e: any) => void
    value?: string | number
    id?: string
    onKeyUp?: (e: any) => void
    onBlur?:(e: any) => void
    min?:number
    max?:number
    step?:number
}

function FormInput(props: PropsType) {
    const {
        formikField = true,
        rightSection = null,
        className = '',
        containerClassName = '',
        type = 'text',
        withMargin = true,
        disabled = false,
        autoComplete = false,
        noClassName = false,
        ...otherProps
    } = props

    let Tag: any = 'input'

    if (formikField) {
        Tag = Field
    }


    const Input = (
        <Tag
            {...otherProps}
            {...autoComplete ? {autoComplete} : {}}
            type={type}
            as={type === 'textarea' ? 'textarea' : 'input'}
            disabled={disabled}
            className={`${noClassName ? '' : 'input'} ${className} ${withMargin ? '' : 'mt-0'}`}/>
    )

    if (rightSection) {
        return (
            <div className={`relative ${containerClassName || ''}`}>
                {Input}
                <div className="absolute bottom-0 right-0 top-0 z-1 flex flex-col items-center justify-center">
                    {rightSection}
                </div>
            </div>
        )
    }


    return Input
}

export default FormInput
